import React from "react";
import classNames from "classnames";
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {observer} from "mobx-react";
// import {LiveCasinoFilterButtonIconBox} from "./boxes/live-casino-filter-button-icon/live-casino-filter-button-icon.box";
import {LiveCasinoFilterButtonLabelBox} from "./boxes/live-casino-filter-button-label/live-casino-filter-button-label.box";
import {ACTIVE} from "../../../../themes/css-global-classes";
import {LiveCasinoArenaNavbarButtonBox} from "./boxes/live-casino-arena-navbar-button/live-casino-arena-navbar-button.box";
import {Link} from "../../../raw-components/link/link";
import {LiveCasinoArenaNavbarButtonWrapperBox} from "./boxes/live-casino-arena-navbar-button/wrapper/live-casino-arena-navbar-button-wrapper.box";

export interface LiveCasinoArenaNavbarButtonProps {
    labelTranslationKey: string;
    filter: string;
    isActiveTab: boolean;
    seoPage: string;
    onClick: () => void;
};

export const LiveCasinoArenaNavbarButton = observer(
    class LiveCasinoArenaNavbarButton extends OrbitComponent<LiveCasinoArenaNavbarButtonProps> {

        private buttonIconMap = new Map([
            ["ITALIAN_GAMES", this.services.theme.currentTheme.icons.italianSpeakingIcon],
            ["TOP_EVO_GAMES", this.services.theme.currentTheme.icons.topGamesIcon],
            ["ROULETTE", this.services.theme.currentTheme.icons.rouletteIcon],
            ["POKER_GAMES", this.services.theme.currentTheme.icons.pokerIcon],
            ["BLACKJACK", this.services.theme.currentTheme.icons.blackjackIcon],
            ["BACCARAT", this.services.theme.currentTheme.icons.baccaratIcon],
            ["ELITE_LOUNGE", this.services.theme.currentTheme.icons.eliteLoungeIcon],
            ["GAME_SHOWS", this.services.theme.currentTheme.icons.gameShowsIcon],
            ["NEW_GAMES", this.services.theme.currentTheme.icons.newGamesIcon],
            ["EXCLUSIVE", this.services.theme.currentTheme.icons.tripleEightExclusiveIcon],
            ["SPEED_GAMES", this.services.theme.currentTheme.icons.speedGames]
        ]);

        private _getButtonIcon() {
            return this.buttonIconMap.get(this.props.labelTranslationKey);
        }

        private _getLabelTranslationKey(): string {
            //this if is a duplicate with the one in live-casino-arena-grid.component.tsx
            // in the future we should look for a way to refactor this for_you logic and have it come from the admin somehow, have only one source of truth
            let currentTranslationKey = this.props.labelTranslationKey;
            if (this.services.user.isAuthorized && currentTranslationKey === "TOP_EVO_GAMES") {
                currentTranslationKey = "FOR_YOU_GAMES";
            }

            return currentTranslationKey;
        }

        onFilterClicked(isActive: boolean) {
            if (!isActive) {
                this.services.analytics.sendOrbitUserFlowEvent("Navigation", "Live Tab", this._getLabelTranslationKey());
                this.props && this.props.onClick();
            }
        }

        render() {
            let IconComponent = this._getButtonIcon();
            return <LiveCasinoArenaNavbarButtonWrapperBox>
                <Link box={LiveCasinoArenaNavbarButtonBox}
                    href={this.props.seoPage}
                    className={
                        classNames(
                            'cy-live-casino-filter-button' + (this.props.filter ? ('-' + this.props.filter) : ''),
                            {[ACTIVE]: this.props.isActiveTab})
                    }
                    onClick={() => this.onFilterClicked(this.props.isActiveTab)}
                >
                    <IconComponent size={this.services.mediaQuery.lAndBelow ? 2 : 2.2} sizeIsHeight backdropOpacity={this.props.isActiveTab ? 0.2 : 0}/>
                    <LiveCasinoFilterButtonLabelBox
                        className={classNames({[ACTIVE]: this.props.isActiveTab})}
                    >
                        {this.services.translation.translate(this._getLabelTranslationKey())}
                    </LiveCasinoFilterButtonLabelBox>
                </Link>
            </LiveCasinoArenaNavbarButtonWrapperBox>;
        }
    }
);
